export default {
  footer: {
    description: "Empowering Latino entrepreneurs to scale their businesses with digital marketing, AI, and automated systems.",
    navTitle: "Navigation",
    servicesTitle: "Services",
    newsletterTitle: "Newsletter",
    newsletterDesc: "Get digital marketing tips, AI, and business updates directly in your inbox.",
    subscribe: "Subscribe",
    subscribing: "Subscribing...",
    subscribeSuccess: "Thanks for subscribing!",
    rights: "© 2024 Smart Business Digital Solutions LLC. All rights reserved.",
    privacy: "Privacy",
    terms: "Terms",
    links: {
      home: "Home",
      about: "About Us",
      services: "Services",
      consulting: "Business Consulting",
      products: "Products",
      contact: "Contact",
      academy: "Academy"
    }
  },
  floating: {
    academy: "Join Academy",
    consultation: "Book Consultation"
  },
  notfound: {
    title: "This page has not been generated",
    subtitle: "Tell me more about this page, so I can generate it"
  }
};
